exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hasError[data-v-1e37054e]{border:1px solid red}", ""]);

// exports
